export const homeSeo = {
  title: "Գլխավոր",
  keywords: "eghoyanshin,Գլխավոր Գլխավոր",
  description: "eghoyanshin.am shinararakan kazmakerputyun",
  ogType: "website",
  ogURL: "https://eghoyanshin.am/",
};

export const aboutSeo = {
  title: "Մեր Մասին",
  keywords: "about me",
  description: "eghoyanshin.am shinararakan kazmakerputyun",
  ogType: "website",
  ogURL: "https://eghoyanshin.am/",
};

export const serviceSeo = {
  title: "Ծառայություններ",
  keywords: "service",
  description: "eghoyanshin.am shinararakan kazmakerputyun",
  ogType: "website",
  ogURL: "https://eghoyanshin.am/",
};